import request from './adminRequest'

const businessApi = {
  listBusiness (params) {
    return request.get('/businesses', {params: params})
  },
  getBusiness (name) {
    return request.get('/businesses/' + name)
  },
  createBusiness (data) {
    return request.post('/businesses', data)
  },
  updateBusiness (data) {
    return request.put('/businesses', data)
  },
  deleteBusiness (name) {
    return request.delete('/businesses/' + name)
  },
}

export default businessApi
